import { isForXStatement } from '@babel/types';
import React, { Component, createRef } from 'react';
import { BsyUtils } from '../../utils/Utils';
import './index.css'

class BsyProgressBar extends Component {

    static defaultProps = {
        baseCls: "bsy_alphaTypePane",
        needDetail: !0,
        allowBlank: !0,
        width: "100%",
        hasNumber: !1,
        hasInputNuber: !1,
        thumbColor: '#0265FF',
        trackColor: '#E0E0E0',
        spotColor: '#FFFFFF',
        spotBorderColor: '#E0E0E0',
        onSpotChange: null,
        showValue: !0,
        valMax: 100,
        valMin: 0,
        max: 1,
        min: 0
    }

    constructor(props) {
        super(props);
        this.state = {
            thumb_width:0,
            value:props.value,
        };

        this.trackRef = React.createRef();
        this.spotRef = React.createRef();
        this.thumbRef = React.createRef();
        this.alphaTypePaneRef = React.createRef();

    }
    
    

    componentDidMount () {
        this.spotBoxOffset = this.spotRef.current.offsetWidth;
        this.trackBoxOffset = this.thumbRef.current.offsetWidth;
        this.paneWidth = this.alphaTypePaneRef.current.offsetWidth - this.spotBoxOffset * 2
        this.blockSize = (this.paneWidth + this.spotBoxOffset) / (this.props.valMax - this.props.valMin )

        this.setState({
            thumb_width: (this.props.value - this.props.valMin) * this.blockSize 
        })

     ;
    }

    UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
       
        const {thumb_width,value} = this.state
        // console.log(value , nextProps.value)
        if (value !== nextProps.value) {
            this.setState({
                thumb_width: (nextProps.value - this.props.valMin) * this.blockSize,
                value:nextProps.value
            })
        }
      }
     

    // thumb_onMouseEnter = (e) => {
    //     console.log(e)
    // }

    // thumb_onMouseLeave = (e) => {
    //     console.log(e)
    // }

    spotBox_onMouseDown = (e) => {

        e.preventDefault();
        e.stopPropagation();
        // console.log(this.spotBox)

        let curentX = e.clientX || e.pageX
        let cursorLeft = parseFloat(this.spotRef.current.style.left || 0);
        this.spotRef.current.style.transition = 'none';
        this.thumbRef.current.style.transition = 'none';
        // this.spotBox.addClass('active');
        // this.thumbBox.addClass('active');
        let spotBoxDown = true;
        // console.log(" mousedown ")
        let mousemove = (event) => {
            if (spotBoxDown) {
                this.thumbRef.current.style.transition = 'none';
                // _this.spotBox.addClass('active');
                // _this.thumbBox.addClass('active');
                var moveX = event.clientX || event.pageX;
                var offsetX = moveX - curentX;

                var pos = cursorLeft + offsetX;
                // console.log('mousemove',moveX, offsetX, pos);
                this.zoomSlierDomBind(pos + 5)
            }
        }
        let mouseup = (event) => {
            // this.thumbBox.removeClass('active');
            // this.spotBox.removeClass('active');
            // console.log(" mouseup ")
            this.spotRef.current.style.transition = "border-color 0.3s";
            spotBoxDown = false;
            document.removeEventListener('mousemove', mousemove, false);
            document.removeEventListener('mouseup', mouseup, false);
        }
        document.addEventListener('mousemove', mousemove, false);
        document.addEventListener('mouseup', mouseup, false);
    }

    zoomSlierDomBind = (ratio) => {
        var _this = this;
        var domPos = ratio;
        var b = this;
        var c = this.props;

        if (domPos > _this.paneWidth + this.spotBoxOffset)
            domPos = _this.paneWidth + this.spotBoxOffset
        if (domPos <= 0)
            domPos = 0;

        // console.log('zoomSlierDomBind ',domPos , this.spotBoxOffset)

        this.thumbRef.current.style.width = domPos + 'px';
        this.spotRef.current.style.left = domPos + 'px';
        this.value = c.valMin + domPos / this.blockSize;
        // console.log(this.value)
        BsyUtils.applyFunc(b, c.onSpotChange, [this.value], !1)

    }

    alphaTypePaneOnClick = (e)=> {
        // console.log(e);
        let xoffset = e.target.getBoundingClientRect().left; //$(this).offset().left,
        let pageX = e.pageX;
        this.thumbRef.current.style.transition = 'none';
        this.zoomSlierDomBind(pageX - xoffset);
        this.thumbRef.current.style.transition = "all 0.3s";
    }

    render() {
        const { thumb_width } = this.state;
        const { showValue } = this.props;
        return (
            <div className="bsy_alphaTypePane"  >
                <div className="alphaTypePaneContent">
                    <div className="alphaTypePane-box" ref={this.alphaTypePaneRef} onMouseDown={this.alphaTypePaneOnClick} style={{}}>
                        <div className="track-box" ref={this.trackRef} ></div>
                        <div className="thumb-box" ref={this.thumbRef} style={{
                            width: thumb_width + 'px'
                        }}
                        // onMouseEnter={this.thumb_onMouseEnter}
                        // onMouseLeave={this.thumb_onMouseLeave}

                        ></div>
                        <div className="spot-box" ref={this.spotRef} style={{
                            left: thumb_width + 'px'
                        }}
                            onMouseDown={this.spotBox_onMouseDown}
                        ></div>
                    </div>
                    {
                        showValue ? <div className="NumberPane-box fui_text x-ui-disable" style={{
                            //display: 'none'; width: 80px; height: 30px
                        }}>
                            <input type="text" className="x-input" readonly="readOnly" />
                            <div className="alphaBtn">
                                <div className="alphaAddBtn">
                                    <i className="icon-angleup"></i>
                                </div>
                                <div className="alphaCutBtn"><i className="icon-bsy-xiala"></i>
                                </div>
                            </div>
                        </div> : ''
                    }

                </div>
            </div>
        );
    }
}

export default BsyProgressBar;